
<script>

import { defineComponent } from 'vue'

import { useToast } from "vue-toastification";

import tinyMCEeditor from '../../../../ui/tinyMCE'
import ComponentGallery from './gallery'
import ComponentLibrary from './library'
import ComponentPhoto from './photo'
import ComponentDocument from './document'

import LoadingButton from '@/components/General/LoadingButton'

//data
import { orderDownComponentArticle,orderUpComponentArticle,deleteComponentArticle,saveComponentArticle } from '@/services/serviceArticle';

export default defineComponent({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ComponentOptions',
		data() {
			return {
				options:[]
				,workComponents:{}
				,isSaving:false
				,isDelete:false
				,isMoveUp:false
				,isMoveDown:false
			}
		},
	props: {
		'components': Object, 'articleId': String
	},
	emits: ["deleteRecord","orderRecord"],
	components: {
		tinyMCEeditor
		,ComponentGallery
		,ComponentLibrary
		,ComponentPhoto
		,ComponentDocument
		,LoadingButton
	}
	,mounted () {
		this.reloadComponents();
	},
	
	methods: {
		reloadComponents:function(){
			this.workComponents = this.components;
		},
		saveComponent:function(component,content,id){
			this.isSaving=true;
			saveComponentArticle({content,id}).then(response => {
				
				if(!response.statusText){
					this.isSaving=false;
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						component.contentWasChanged=false;
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isSaving=false;
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},

		deleteComponent:function(componentId){
			
			if(componentId){
				this.isDelete=false;
				deleteComponentArticle({componentId}).then(response => {
					if(!response.statusText){
						this.isDelete=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasDeleted'));
							this.$emit('deleteRecord', '')
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeDeleted'));
						}else if(response.resCode==2){
							this.toast.error(this.$t('msgCore.dataWasNotDeleted'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isDelete=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
			}
			
		},


		orderUpComponent:function(ordering,id){
			this.isMoveUp=true;
			orderUpComponentArticle({articleId:this.articleId,ordering,id}).then(response => {
				
				if(!response.statusText){
					this.isMoveUp=false;
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.$emit('orderRecord')
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isMoveUp=false;
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		orderDownComponent:function(ordering,id){
			this.isMoveDown=true;
			
			orderDownComponentArticle({articleId:this.articleId,ordering,id}).then(response => {
				if(!response.statusText){
					this.isMoveDown=false;
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.$emit('orderRecord')
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isMoveDown=false;
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		handleChangeEditor(e) {
			//kontrola zmeny obsahu
			this.component=e
			const index = this.workComponents.findIndex((item => item.id === e.id))
			this.workComponents[index]=e
			console.log(e)
			//e.contentWasChanged=true;
		},

		handleChangeGallery(e) {
			//kontrola zmeny obsahu
			this.component=e
			const index = this.workComponents.findIndex((item => item.id === e.id))
			this.workComponents[index]=e
			e.contentWasChanged=true;
		},

		handleChangeLibrary(e) {
			//kontrola zmeny obsahu
			this.component=e
			const index = this.workComponents.findIndex((item => item.id === e.id))
			this.workComponents[index]=e
			e.contentWasChanged=true;
		},

		handleChangePhoto(e) {
			//kontrola zmeny obsahu
			this.component=e
			const index = this.workComponents.findIndex((item => item.id === e.id))
			this.workComponents[index]=e
			e.contentWasChanged=true;
		},

		handleChangeDocument(e) {
			//kontrola zmeny obsahu
			this.component=e
			const index = this.workComponents.findIndex((item => item.id === e.id))
			this.workComponents[index]=e
			e.contentWasChanged=true;
		}
	},
	
	watch: {
		components() {
			this.reloadComponents();
		},
		component() {
			console.log(this.component);
		},
	},
	
	created() {

	}
})
</script>

<template>
	<div>
		
			<div v-for="(component, index) in components" :key="component.id">

				<div class="col-12 pt-1 mt-3 component-block">

					<div class="row">

						<div class="col-md-1">
							{{(index+1)}} 
						</div>

						<div class="col-md-5">
							<h4 v-if="component.componentId==1">
								Textový editor
							</h4>

							<h4 v-else-if="component.componentId==2">
								Galéria
							</h4>

							<h4 v-else-if="component.componentId==3">
								Knižnica
							</h4>

							<h4 v-else-if="component.componentId==4">
								Dokument
							</h4>

							<h4 v-else-if="component.componentId==5">
								Fotka
							</h4>
						</div>

						<div class="col-md-6 col-12 text-end">
							<div class="btn-group">
								<LoadingButton :isDisabled="false" :isSending="isSaving" @onClick="saveComponent(component,component.content,component.id)" :label="'msgCore.btnSave'" color="warning"></LoadingButton>

								<LoadingButton :isDisabled="false" :isSending="isDelete" @onClick="deleteComponent(component.id)" :label="'msgCore.btnDelete'" color="danger"></LoadingButton>

								<LoadingButton :isDisabled="index==0" :isSending="isMoveUp" @onClick="orderUpComponent(component.ordering,component.id)" :label="'msgCore.btnOrderUp'" color="secondary"></LoadingButton>

								<LoadingButton :isDisabled="(index+1==components.length)" :isSending="isMoveDown" @onClick="orderDownComponent(component.ordering,component.id)" :label="'msgCore.btnOrderDown'" color="secondary"></LoadingButton>
							</div>
						</div>

						<div v-if="component.contentWasChanged" class="col-12 mt-3">
							<div class="alert alert-warning">
								Obsah bol zmenený
							</div>
						</div>

						<div v-if="component.componentId==1" class="col-12 pb-5  component-row">
							<tinyMCEeditor :content="component" @changeContent="handleChangeEditor" />
						</div>

						<div v-else-if="component.componentId==2" class="col-12 pb-5  component-row">
							<ComponentGallery :content="component"  @changeContent="handleChangeGallery" />
						</div>
						
						<div v-else-if="component.componentId==3" class="col-12 pb-5  component-row">
							<ComponentLibrary :content="component" @changeContent="handleChangeLibrary" />
						</div>

						<div v-else-if="component.componentId==4" class="col-12 pb-5  component-row">
							<ComponentDocument :content="component" @changeContent="handleChangeDocument" />
						</div>

						<div v-else-if="component.componentId==5" class="col-12 pb-5  component-row">
							<ComponentPhoto :content="component" @changeContent="handleChangePhoto" />
						</div>

					</div>
				</div>

			</div>
	
	</div>
</template>